/* eslint-disable */

import 'react-confirm-alert/src/react-confirm-alert.css' // Import css
import './SignIn_SignUpcss.css';
import 'sweetalert2/src/sweetalert2.scss';

import { NavLink, Route, BrowserRouter as Router } from 'react-router-dom';
import React, { Component, Suspense, lazy } from 'react';

import $ from 'jquery';
import GoogleLogin from 'react-google-login';
import { LoadingPage } from './LoadingPage';
import { LoginFunc } from './LoginPageFunc';
import ReactDOM from 'react-dom';
import SignUp from './SignUp';
import logomb from './image/tictokn40.png';
import useResetUrl from './CommonComponents/CommonComponents';

const ForgotPassword = lazy(() => import('./ForgotPassword'));
const LandingPage = lazy(() => import('./LandingPage'));

var encrypted;

class SignIn extends Component {

    constructor() {
        super()
        this.state = {

            //  emailId: '',
            //  password: '',
            date: '',
            formValid: false,
            formErrors: { emailId: '', password: '' },
            emailIdValid: false,
            passwordValid: false,
        };
    }

    componentDidMount(){
        useResetUrl();
    }
    handleUserInput = (e) => {
        console.log("HANDLE USER INPUT :", e);

    
        const name = e.target.name;
        const value = e.target.value; 

        this.state.userName=value;
        this.setState({
            userName:this.state.userName
        })

        this.setState({ [name]: value },
            () => { this.validateField(name, value) });
    }

   
    handleUserPassword = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value },
            () => { this.validateField(name, value) });
    }

    signup() {
        ReactDOM.render(
            <Router>
                <Suspense fallback={<LoadingPage />}>
                    <div >
                        <Route  path="/" component={SignUp} />
                    </div>
                </Suspense>
            </Router>, document.getElementById('root'));

    }
    login() {

        var today = new Date();
        today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
        this.state.date = today;

        this.setState({
            emailId: this.state.emailId,
            password: this.state.password,
            mobileNo: this.state.mobileNo,
            date: today,
        });
        var key = "shinchanbaby";


        var self = this;



        LoginFunc(this.state);

        self.state.emailId = "";
        self.state.firstName = "";
        self.state.lastName = "";


        self.setState({
            emailId: self.state.emailId,
            firstName: self.state.firstName,
            lastName: self.state.lastName,
        })


    }
    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let emailIdValid = this.state.emailIdValid;
        let passwordValid = this.state.passwordValid;

        switch (fieldName) {

            case 'emailId':
                emailIdValid = value.length >= 5;
                { /*  emailIdValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);*/ }
                fieldValidationErrors.emailId = emailIdValid ? '' : ' is invalid';
                break;
            case 'password':
                passwordValid = value.length >= 5 && value.match(/^((?=.*[0-9])(?=.*[A-Z])(?=.{8,})(?!.* ))/);
                fieldValidationErrors.password = passwordValid ? '' : ' is too short';
                break;
            default:
                break;
        }
        this.setState({
            formErrors: fieldValidationErrors,
            emailIdValid: emailIdValid,
            passwordValid: passwordValid
        }, this.validateForm);
    }

    validateForm() {
        this.setState({ formValid: this.state.emailIdValid && this.state.passwordValid });
    }

    errorClass(error) {
        return (error.length == 0 ? '' : 'has-error');
    }
    Fpassword() {
        ReactDOM.render(<ForgotPassword />, document.getElementById('root'));
    }

    HomeFunc() {

        ReactDOM.render(
            <Router>
                <Suspense fallback={<LoadingPage />}>
                    <div >
                        <Route path="/" component={LandingPage} />

                    </div>
                </Suspense>
            </Router>
            , document.getElementById("root"));

    }


    show_Password() {
        var passwordInput = document.getElementById('password-field');
        var passStatus = document.getElementById('pass-status');

        if (passwordInput.type == 'password') {
            passwordInput.type = 'text';
            passStatus.className = 'fa fa-eye-slash';

        }
        else {
            passwordInput.type = 'password';
            passStatus.className = 'fa fa-eye';
        }
    }

    Fpassword() {
        ReactDOM.render(
            <Router>
                <Suspense fallback={<LoadingPage />}>
                    <div >
                        <Route path="/" component={ForgotPassword} />

                    </div>
                </Suspense>
            </Router>
            , document.getElementById("root"));
    }

    render() {
        const responseGoogleSignIn = (response) => {
            console.log("RESPONSE GOOGLE :", response);

            var self = this;
            if (response.profileObj  && response.profileObj.email != "") {

                this.state.firstName = response.profileObj.givenName;
                this.state.lastName = response.profileObj.familyName;
                this.state.emailId = response.profileObj.email;
                this.state.password = "ThirdPartySignIn";

                //CALL THE LOGIN FUNC WITHOUT PASSWORD
                //this.SignUpFunc();
                LoginFunc(this.state);

                self.state.emailId = "";
                self.state.firstName = "";
                self.state.lastName = "";
                self.state.password = "";

                self.setState({
                    emailId: self.state.emailId,
                    firstName: self.state.firstName,
                    lastName: self.state.lastName,
                    password: self.state.password,
                })
            }
        }



        return (
            <div class="container-fluid signinfont" style={{ backgroundColor: "whitesmoke" }}>
                <div className="row">
                    <div class="col-md-6" style={{ padding: "0px" }}>
                        <div class="signup_page_wrap">
                            <div class="signup_page">
                                <div class="old_account">
                                    <p class="logomb">
                                        {/* <img src={logomb} /> */}
                                        <span class="logotext" >letzcheckin.com</span>
                                    </p>
                                </div>
                                <form className="Sign_In_form" >
                                    <h3>Welcome Back!</h3>
                                    <label class="mt-top">Username</label>
                                    <input type="email" value={this.state.emailId} onChange={this.handleUserInput}
                                        name="emailId" id="emailId" className="form-control" required="" autoFocus="" placeholder="Email or Phone Number" />
                                    <div class="show_pwd">
                                        <label class="mt-top">Password</label>
                                        <input type="password" value={this.state.password} onChange={this.handleUserPassword} name="password" id="password-field" className="form-control" required="" placeholder="Password" /><i class="fa fa-eye" id="pass-status" aria-hidden="true" onClick={this.show_Password}></i>
                                        {!this.state.formValid ? <span style={{ fontSize: "10px", color: "red" }}>Use atleast 8 characters, should have atleast one uppercase letter,one lower letter, a number and no space</span> : ""}
                                    </div>


                                    <div className="signIn_fpwd" ><a class="color" style={{ fontSize: "12px" }} href="#" onClick={() => this.Fpassword()}>Forgot your password?</a></div>

                                    <button type="button" disabled={!this.state.formValid}
                                        onClick={() => this.login()}
                                        className="signIn_btn btn btn-primary" >Login</button>
                                    <div class="text-center mt-top">
                                        <h3 className="orsignin_cls" style={{ marginBottom: "20px" }}> or </h3>
                                        <GoogleLogin class="mt-top"
                                            clientId="543894373402-gmusj94l3obtrfvl273upb6o5lrvqrcd.apps.googleusercontent.com"
                                            buttonText="Login with Google"
                                            className="goole_loginbtn"
                                            onSuccess={responseGoogleSignIn}
                                            onFailure={responseGoogleSignIn}
                                        />
                                    </div>

                                </form>
                                <div class="text-center" style={{ marginTop: "10px" }}>
                                    <p class="signup"><span>Don't have an account?</span>
                                        <span class="btn-accn" onClick={this.signup}>Sign Up</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 rightsidesignup" style={{ padding: "0px" }}>
                        <div class="rightside_img rightside_imglogin">
                            {/* <img src={screenshot} /> */}
                        </div>
                    </div>
                </div>


            </div>
        );
    }
}

export default SignIn;

